<template class="banner">
   <v-dialog persistent v-model="this.open" width="70vw">
        <img :src="this.url" alt="">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            right
            @click="confirm"
          >
            Ok
          </v-btn>
        </v-card-actions>
    </v-dialog>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
const user = createNamespacedHelpers('user')

export default {
    name: 'BannerModal',
    props: ['open', 'url', 'banner'],
    data() {
        return {}
    },
    computed: {
       ...user.mapGetters(['user'])
    },
    methods: {
      confirm(){
        localStorage.setItem('bannerAlreadyShown', true)
        this.$emit('closeModal')
      },
  }
}
</script>
<style scoped>
*::-webkit-scrollbar {
  width: 1em;
}
 
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(7, 7, 7, 0.3);
}
 
*::-webkit-scrollbar-thumb {
  background-color: rgb(119, 113, 113);
  border-radius:8px;
}
</style>